<template>
  <drop-helper :dropOptions="dropOptions"></drop-helper>
</template>

<script>
import DropHelper from '@/components/DragDrop/DropHelper';
import { mapGetters, mapState, mapActions } from 'vuex';

export default {
  components: { DropHelper },
  props: ['item', 'pageNotes', 'pageId', 'showDoc'],
  data() {
    return {
      accepts: ['noteBlock'],
      firstDraggedItem: null,
      idsToMove: [],
      savedDragData: []
    };
  },
  watch: {
    draggedData: function(n, o) {
      if (n && n.ids.length && (!o || n.ids != o.ids)) {
        //  store the value of dragged data so when drag stops we still have it to execute on
        this.firstDraggedItem = n.items[0];
        this.idsToMove = n.ids;
        this.savedDragData = n;
      } else {
        
      }
    }
  },
  computed: {
    ...mapGetters('pages', ['selectedPageNotes']),
    ...mapState('pages', ['pages']),
    ...mapState('views/context', ['selectedPageId']),
    ...mapGetters('components/dragdrop', ['dragging']),
    ...mapState('components/dragdrop', ['draggedData']),
    selectedPageNotes() {
      return this.pageNotes;
    },
    dropOptions() {
      return {
        accepts: this.accepts,
        zones: [
          //  handle sorting questions
          {
            id: 'sortAbove',
            show: this.isSortable && !this.isNextItemDown,
            style: {
              top: 0,
              left: 0,
              right: 0,
              height: this.isDragIntoable ? '10px' : 'auto',
              bottom: this.isDragIntoable ? 'auto' : this.isNextItemUp ? 0 : '49%'
            },
            hoverWidth: 100,
            hoverClass: 'q-dropzone-top',
            onDrop: () => this.moveItem(this.isSortingDown && this.isSameDoc ? -1 : 0)
          },
          {
            id: 'sortBelow',
            show: this.isSortable && !this.isNextItemUp,
            style: {
              top: this.isDragIntoable ? 'auto' : this.isNextItemDown ? '1px' : '52%',
              height: this.isDragIntoable ? '10px' : 'auto',
              left: 0,
              right: 0,
              bottom: 0
            },
            hoverWidth: 100,
            hoverClass: 'q-dropzone-bottom',
            onDrop: () => this.moveItem(this.isSortingUp || !this.isSameDoc ? 1 : 0)
          },
          {
            id: 'droppable',
            show: this.isDragIntoable && !this.showDoc,
            style: {
              top: '10px',
              left: 0,
              right: 0,
              bottom: '10px'
            },
            hoverClass: 'q-dropzone-merge',
            hoverWidth: 100,
            zoneClass: 'zone-merge',
            //hoverClass: 'hover-zone-move',
            onDrop: () => this.dropItem()
          },
          // {
          //   id: 'combineExcerpts',
          //   show: this.isCombinable,
          //   style: {
          //     top: '10px',
          //     left: 0,
          //     right: 0,
          //     bottom: '10px'
          //   },
          //   hoverClass: 'q-dropzone-merge',
          //   hoverWidth: 100,
          //   zoneText: 'COMBINE EXCERPTS',
          //   zoneIcon: 'call_received',
          //   zoneClass: 'zone-merge',
          //   //hoverClass: 'hover-zone-move',
          //   onDrop: () => this.combine()
          // }
        ]
      };
    },
    active() {
      const matchedAccepts = this.accepts.filter(value => this.draggedData.types.includes(value));
      return this.dragging && matchedAccepts.length > 0;
    },
    draggedItems() {
      console.log('calc draggedData items')
      return this.active ? this.savedDragData.items : [];
    },
    isDragged() {
      return this.active && this.savedDragData.ids.includes(this.item.id);
    },
    isSortable() {
      return this.active && !this.isDragged && this.savedDragData.types.includes('noteBlock');
    },
    isCombinable() {
      return false;
      try {
        return (
          !this.isDragged &&
          this.item.type == 'widget' &&
          this.item.content.widgetData.resourceNoteIds.length > 0 &&
          this.savedDragData.types.includes('noteBlock') &&
          this.savedDragData.ids.length == 1 &&
          this.firstDraggedItem.type == 'widget' &&
          this.firstDraggedItem.content.widgetData.resourceId ==
            this.item.content.widgetData.resourceId
        );
      } catch (e) {
        console.log(e);
        return false;
      }
    },
    isDragIntoable() {
      try {
        return this.active && !this.isDragged && this.item.type == 'card';
      } catch (e) {
        console.log(e);
        return false;
      }
    },
    isSortingUp() {
      return this.isSameDoc && this.item.order < this.firstDraggedItem.order;
    },
    isSortingDown() {
      return this.isSameDoc && this.item.order > this.firstDraggedItem.order;
    },
    isNextItemUp() {
      return this.isSameDoc && this.firstDraggedItem.order - 1 == this.item.order;
    },
    isNextItemDown() {
      const lastDraggedItem = this.draggedItems.length
        ? this.draggedItems[this.draggedItems.length - 1]
        : {};
      return this.isSameDoc && lastDraggedItem.order + 1 == this.item.order;
    },
    isSameDoc() {
      return this.active && this.savedDragData.parent.id == this.pageId;
    }
  },
  methods: {
    ...mapActions('pages', ['moveNoteById', 'combineExcerptNoteBlocks']),
    moveItem(offsetOrder = 0) {
      console.log('move item', this.pageId);
      console.log(this.firstDraggedItem);
      const noteIds = this.idsToMove;
      const moveToPosition = this.item.order + offsetOrder;
      //const pageId = this.pageId;
      const moveFromPageId = this.savedDragData.parent.id;
      const moveToPageId = this.pageId;
      this.moveNoteById({ noteIds, moveToPageId, moveFromPageId, moveToPosition });
    },
    dropItem() {
      console.log('drop item', this.pageId);
      console.log(this.firstDraggedItem);
      const noteIds = this.idsToMove;

      const dropToPage = this.pages[this.item.pageId];
      const dropPagePageNotes = Object.values(dropToPage.pageNotes).filter(p => !p.toDelete);

      const moveToPosition = dropPagePageNotes.length;
      //const pageId = this.pageId;
      const moveFromPageId = this.savedDragData.parent.id;
      const moveToPageId = this.item.pageId;
      this.moveNoteById({ noteIds, moveToPageId, moveFromPageId, moveToPosition });
    },
    combine() {
      console.log(this.firstDraggedItem, this.item.id, this.selectedPageId);
      this.combineExcerptNoteBlocks({
        noteIdToMove: this.firstDraggedItem.id,
        targetId: this.item.id,
        pageId: this.selectedPageId
      });
    }
  }
};
</script>

<style>
.q-dropzone-top {
  border-top: 3px solid #2196f3;
}

.q-dropzone-bottom {
  border-bottom: 3px solid #2196f3;
  margin-bottom: -3px;
}
.q-dropzone-merge {
  background: #2195f345;
}

.zone-merge .drop-zone-content {
  opacity: 0;
  color: #242424;
  font-weight: bold;
  border-radius: 2px;
  background: rgba(255, 255, 255, 0.76);
  transition: 0.5s ease all;
}

.zone-merge.hover .drop-zone-content {
  opacity: 1;
  color: #242424;
  font-weight: bold;
  border-radius: 2px;
  background: rgba(255, 255, 255, 0.76);
  transition: 0.5s ease all;
}
</style>
